import { render, staticRenderFns } from "./logisticsView.vue?vue&type=template&id=26a4db34&scoped=true"
import script from "./logisticsView.vue?vue&type=script&lang=js"
export * from "./logisticsView.vue?vue&type=script&lang=js"
import style0 from "./logisticsView.vue?vue&type=style&index=0&id=26a4db34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a4db34",
  null
  
)

export default component.exports